/*
 * Created by alex@hackerbay.com on 4.1.2019
 * Copyright Singularity Technologies GmbH (c) 2019. All rights reserved
 */
import * as axios from "axios";
import {getAPIUrl} from "./common";
import moment from "moment";

/**
 * Debugging Switch to activate Console Logging for Stages
 * @type {boolean}
 */
const DEBUG = true;

const ENDPOINT = "appointmentSetup";
const loadDS360Data = async(urlIdent) => {

    if( DEBUG ) console.log( "#########################################################################################");
    if( DEBUG ) console.log( "FNX: ds360.js // loadDS360Data // urlIdent = " + urlIdent );
    if( DEBUG ) console.log( "FNX: ds360.js // loadDS360Data // API-URL = " + getAPIUrl(ENDPOINT, `urlIdent=${urlIdent}`) );
    return await axios.get(getAPIUrl(ENDPOINT, `urlIdent=${urlIdent}`));

};


/**
 * saveAppointmentDate
 * API Endpoint = "appointmentSetup" (s.o. const)
 *
 * @param urlIdent
 * @param state
 * @param selectedDate
 * @returns {Promise<*>}
 */
const saveAppointmentDate = async(urlIdent, state, selectedDate) => {

    state.urlIdent = urlIdent;
    state.selectedDate = selectedDate;

    console.log( "FNX: saveAppointmentDate // state:" );
    console.log( state );

    // POST to API via axios (waiting for response)
    return await axios.post(getAPIUrl(ENDPOINT, undefined), state)

};



/**
 * saveCustomerData
 * API Endpoint = "appointmentSetup" (s.o. const)
 *
 * @param urlIdent
 * @param state
 * @param selectedDate
 * @returns {Promise<*>}
 */
const saveCustomerData = async(urlIdent, state) => {

    state.urlIdent = urlIdent;

    if( DEBUG ) console.log( "#########################################################################################");
    if( DEBUG ) console.log( "FNX: ds360.js // saveCustomerData // Cloudfunction-URL:" + getAPIUrl(ENDPOINT, undefined) );
    if( DEBUG ) console.log( "FNX: ds360.js // saveCustomerData // state:" );
    if( DEBUG ) console.log( state );

    let postData = {};

    // action = appointment
    if( state.apiAction == "appointment" ) {
        postData = {
            action: state.apiAction,
            urlIdent: urlIdent,
            selectedDate: state.selectedDate,
            Response_Hinweis_Techniker: state.Response_Hinweis_Techniker,
            Check_Anwesenheit: state.warningTextYesAtHome,
            benachrichtigungPer: state.benachrichtigungPer,
        };
    }

    // action = callback
    if( state.apiAction == "callback" ) {
        postData = {
            action: state.apiAction,
            urlIdent: urlIdent,
            Response_Rueckrufnummer: state.phoneNumber,
            benachrichtigungPer: state.benachrichtigungPer,
        };
    }

    // action = installed
    if( state.apiAction == "installed" ) {
        postData = {
            action: state.apiAction,
            urlIdent: urlIdent,
            benachrichtigungPer: state.benachrichtigungPer,
        };
    }

    // action = cancel
    if( state.apiAction == "cancel" ) {
        postData = {
            action: state.apiAction,
            urlIdent: urlIdent,
            benachrichtigungPer: state.benachrichtigungPer,
        };
    }

    // POST to API via axios (waiting for response)
    if( DEBUG ) console.log( "FNX: ds360.js // saveCustomerData // postData:" );
    if( DEBUG ) console.log( postData );
    return await axios.post(getAPIUrl(ENDPOINT, undefined), postData)

};


/**
 * save customer validation data to DSL API using URL_IDENT
 * (URL_IDENT will be translated to KAS_BARCODE in App API Client /functions/...)
 * @param urlIdent
 * @param bValidation
 * @returns {Promise<void>}
 */
const saveCustomerValidationData = async(urlIdent, bValidation) => {

    const ENDPOINT = "customerValidation";
    const validationApiUrl = getAPIUrl(ENDPOINT, `urlIdent=${urlIdent}`);
    const validationData = { urlIdent: urlIdent, customerValidation: bValidation };

    // console.log( "FNX: saveCustomerValidationData / validationApiUrl: " + validationApiUrl);
    // console.log( "FNX: saveCustomerValidationData / validationData: " + JSON.stringify ( validationData ) );

    // POST to API via axios (waiting for response)
    return await axios.post( validationApiUrl, validationData );

};

export {loadDS360Data, saveAppointmentDate, saveCustomerData, saveCustomerValidationData};
